'use strict';

function CreditScoreEducational() {
  this.id = null;
  this.node = null;
  this.extends = [Educational];

  this.contentId = ''; // 'credit-score' (defined in pug file)
  this.history = new History();

  this.init = function () {
    this.initPage();
  };

  this.initPage = function () {
    this.initEducational();
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this.destroyEducational();
  };
}